import React from 'react';
import i18n from 'asset/translation';
import { StyledDataAvailability } from 'adapter/in/common/components/widgets/DataAvailability/style';
import { RawAvailability, WidgetDataAvailability } from 'domain/entity/widgetData';
import { fraction, add, Fraction, number } from 'mathjs';
import { Tooltip, colors } from '@dexma/ui-components';

type DataAvailabilityProps = {
    dataAvailability: WidgetDataAvailability;
};

const useDataAvailability = (rawAvailabilities: RawAvailability[]): string => {
    const base = number(
        rawAvailabilities.reduce(
            (previousValue: Fraction, currentValue: RawAvailability) =>
                fraction(add(previousValue, fraction((currentValue.available * currentValue.weight) / currentValue.expected))),
            fraction(0, 1)
        )
    );
    return Math.floor((base / rawAvailabilities.length) * 100).toString();
};

const DataAvailability = (props: DataAvailabilityProps): JSX.Element => {
    const { dataAvailability } = props;

    const mapTooltipTitle = (rawAvailabilities: RawAvailability[]): JSX.Element =>
        rawAvailabilities.reduce(
            (child: JSX.Element, rawAvailability: RawAvailability) => (
                <>
                    {child}
                    <span>
                        {rawAvailability.name}: {Math.floor((rawAvailability.available / rawAvailability.expected) * 100)}%
                    </span>
                    <br />
                </>
            ),
            <></>
        );
    return (
        <>
            {dataAvailability && dataAvailability.enabled && (
                <StyledDataAvailability color={colors.gray800} variant='outline' type='rounded'>
                    <Tooltip title={mapTooltipTitle(dataAvailability.rawAvailabilities)}>
                        {useDataAvailability(dataAvailability.rawAvailabilities)}% {i18n.t('common.data')}
                    </Tooltip>
                </StyledDataAvailability>
            )}
        </>
    );
};

export default DataAvailability;
